


























import Vue from "vue";

export default Vue.extend({
  name: "VButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ""
    },
    loading: {
      default: false,
      type: Boolean
    },
    type: {
      type: String,
      default: "button",
      validator: (value: string): boolean =>
        ["button", "submit", "reset"].includes(value)
    },
    view: {
      type: String,
      required: true,
      validator: (value: string): boolean =>
        ["primary", "secondary", "tertiary", "outline"].includes(value)
    },
    outline: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes(): Record<string, string | boolean> {
      return {
        [`button--${this.view}`]: this.view,
        "button--flat": this.flat,
        "button--round": this.round,
        "button--dense": this.dense
      };
    }
  },

  methods: {
    onClick(e: Event): void {
      if (this.loading) {
        e.preventDefault();
      } else {
        this.$emit("click");
      }
    },

    onMouseDown(e: Event): void {
      e.preventDefault();
    }
  }
});
